import { impactMap } from "@/views/Impact/Data/impactMap";

export function getImgSourceFromName(name) {
  const impact = impactMap.find((item) => item.title === name);
  return impact ? impact.img : null;
}
